<template>
  <div>
    <vx-card class="mb-8" title="Lieferzeit">
      <div class="flex items-end my-4">
        <vs-input
          class="mr-4"
          style="width: 160px"
          label="Lieferzeit (Minuten)"
          type="number"
          min="0"
          v-model="deliveryTime"
          placeholder="z.B. 45"
        />
        <vs-button
          color="primary"
          type="filled"
          @click="onUpdateDeliveryTime"
          :disabled="!deliveryTime"
        >
          Aktualisieren
        </vs-button>
      </div>
    </vx-card>

    <vx-card title="Lieferstatus">
      <div class="flex items-center justify-between my-4">
        <div class="flex items-center">
          <div
            class="h-4 w-4 rounded-full mr-3"
            :style="{
              backgroundColor: deliveryPossible ? '#2ECC71' : '#EA5455',
            }"
          ></div>
          <span class="text-lg">
            Lieferungen sind momentan
            <strong>{{ deliveryPossible ? "aktiv" : "deaktiviert" }}</strong>
          </span>
        </div>
        <vs-button
          :color="deliveryPossible ? 'danger' : 'success'"
          type="filled"
          @click="onToggleDeliveryActivation"
        >
          {{ deliveryPossible ? "Deaktivieren" : "Aktivieren" }}
        </vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  computed: {
    deliveryTime() {
      return this.$store.state.orders.deliveryTime;
    },
    deliveryPossible() {
      return this.$store.state.orders.deliveryPossible;
    },
  },
  created() {
    this.getDeliveryTime();
  },
  methods: {
    ...mapActions({
      getDeliveryTime: "orders/getDeliveryTime",
    }),
    onUpdateDeliveryTime() {
      this.$store.dispatch("orders/updateDeliveryTime", this.deliveryTime);
    },
    onToggleDeliveryActivation() {
      this.$store.dispatch("orders/deliveryActivation", !this.deliveryPossible);
    },
  },
};
</script>

<style scoped>
::v-deep input[type="number"]::-webkit-outer-spin-button,
::v-deep input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
</style>
